var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5E87CA;}\r\n\t.st1{fill:#F2F2F2;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#F9D266;}\r\n\t.st4{fill:#F0AE42;}\r\n\t.st5{fill:#D5883E;}\r\n\t.st6{fill:#FCE797;}\r\n\t.st7{fill:#C0DAFC;}\r\n\t.st8{fill:#78A0D4;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.8,0.7h30.4c0.6,0,1.1,0.5,1.1,1.1v20.6c0,0.6-0.5,1.1-1.1,1.1H1.8c-0.6,0-1.1-0.5-1.1-1.1V1.8 C0.7,1.2,1.2,0.7,1.8,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.1,21.3h23.9c0-1.2,1-2.2,2.2-2.2V5.1c-1.2,0-2.2-1-2.2-2.2H5.1c0,1.2-1,2.2-2.2,2.2v14.1 C4.1,19.2,5.1,20.1,5.1,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29,3.3c0-0.1,0-0.3,0-0.5H5.1c0,1.2-1,2.2-2.2,2.2v14.1c0.6,0,1.1,0.2,1.5,0.6h23.5c0.6,0,1.1-0.5,1.1-1.1 V3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.1,24.3v5.2l-2.2-2.2l-2.2,2.2v-6.1c0.3,0.1,0.6,0.2,0.9,0.2c0.4,0,0.7,0.2,0.9,0.4 C16.3,24.7,17.3,24.8,18.1,24.3L18.1,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20.3,23.4v9.9l-2.2-2.2l-2.2,2.2v-6l2.2,2.2v-5.2c0.1-0.1,0.2-0.2,0.3-0.2c0.3-0.2,0.6-0.4,0.9-0.4 C19.7,23.6,20,23.6,20.3,23.4L20.3,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.1,20.6c0.2,0.3,0.4,0.6,0.4,0.9c0,1.1,0.9,2,2.1,2.1c0.4,0,0.7,0.2,0.9,0.4c0.8,0.7,2,0.7,2.9,0 c0.3-0.2,0.6-0.4,0.9-0.4c1.1,0,2-0.9,2.1-2.1c0-0.4,0.2-0.7,0.4-0.9c0.7-0.8,0.7-2,0-2.9c-0.2-0.3-0.4-0.6-0.4-0.9 c0-1.1-0.9-2-2.1-2.1c-0.4,0-0.7-0.2-1-0.4c-0.8-0.7-2-0.7-2.9,0c-0.3,0.2-0.6,0.4-0.9,0.4c-1.1,0-2,0.9-2.1,2.1 c0,0.4-0.2,0.7-0.4,1C11.4,18.6,11.4,19.8,12.1,20.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 17,
    cy: 19.2,
    r: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M14.3,19.2c0,0.5,0.1,0.9,0.3,1.3c0.4,0.2,0.8,0.3,1.3,0.3c1.5,0,2.7-1.2,2.7-2.7c0-0.5-0.1-0.9-0.3-1.3 c-0.4-0.2-0.8-0.3-1.3-0.3C15.5,16.5,14.3,17.7,14.3,19.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12.1,4.5h9.8v1.1h-9.8V4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M8.9,6.7h16.3v1.1H8.9V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M6.7,8.9h20.6v1.1H6.7V8.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M24.1,18.6h3.3v1.1h-3.3V18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M6.7,18.6h3.3v1.1H6.7V18.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/Certificate.ea95d461d056db73a51fd6a956cdd787.svg";
export { ForwardRef as ReactComponent };